import React from 'react';
const createReactClass = require('create-react-class');
const PageNotFound = createReactClass({

  componentWillMount() {
    if (localStorage.jwtToken) {
      const token = localStorage.jwtToken;
      this.props.signedIn(token);
    }
  },
  componentDidMount() {
    window.scrollTo(0, 0)
  },
  render() {
    return (
      <div>
        <div className="body-wrapper">
          {/* <section className="container not-found">
            <div className="row">
              <div className="clearfix">
                <div className="col-sm-offset-1 col-xs-4 col-sm-4 col-md-4 col-lg-4">
                  <img src="img/404box.jpeg" className="img-responsive" alt="" />
                </div>
                <div className="col-xs-7 col-sm-7 col-md-7 col-lg-7 text-left">
                  <h1>Page not found,</h1>
                  <h3>but this guy found our supply of boxes. Kidding!</h3>
                  <br />
                  <br />
                  <p>The Page was most likely moved, updated, or removed.</p>
                  <p>These should point you in the right direction:</p>
                  <div className="list-group text-primary">
                    <Link to="/home" className="text-primary">Home</Link>
                    <Link to="/promotions" className="text-primary">Promotions</Link>
                    <Link to="/special-handling" className="text-primary">Special Handling</Link>
                    <Link to="/prohibited-items" className="text-primary">Prohibited Items</Link>
                    <Link to="/terms-conditions" className="text-primary">Terms and Conditions</Link>
                    <Link to="/help-center" className="text-primary">Help Center</Link>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          <section className="container not-found">
            <div className="row">
              <div className="main-img">
                  <img alt="temp" src="https://cdn.shippingcart.com/images/front/404-image4.jpg" className="img-responsive" />
              </div>

              <div className="main-right">
                  <h1>Can't find what you're looking for?</h1>

                  <p>The Page was most likely moved, updated, or removed.
                        These should point you in the right direction:
                  </p>

                  <div className="help-static">
                      <p>
                          <i className="fa fa-chevron-right" aria-hidden="true"></i>
                          Want to know <a href="/usa-to-philippines-shipping">how to use</a> ShippingCart?
                      </p>

                      <p>
                          <i className="fa fa-chevron-right" aria-hidden="true"></i>
                          Want to know our <a href="/shipping-rates-usa-to-philippines">rates</a>?
                      </p>

                      <p>
                          <i className="fa fa-chevron-right" aria-hidden="true"></i>
                          Want to know our current <a href="/promotions">promos</a>?
                      </p>

                      <p>
                          <i className="fa fa-chevron-right" aria-hidden="true"></i>
                          Have other questions? Visit our <a href="/faqs">help center</a>.
                      </p>
                  </div>

                  <div className="help-category">
                    <h3>Need help on where to shop for finds in the US?</h3>

                    <a href="/shop-health-beauty">
                    <div className="category">
                        <div className="cat1">
                            <div className="image">
                                <img alt="temp" src="https://cdn.shippingcart.com/images/front/shop-health-page.png" />
                            </div>
                            <div className="text">
                                Shop Health &#38; Beauty
                            </div>
                            <div className="arrow">
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    </a>

                    <a href="/shop-home-garden">
                    <div className="category">
                        <div className="cat2">
                            <div className="image">
                                <img alt="temp" src="https://cdn.shippingcart.com/images/front/shop-home-page.png" />
                            </div>
                            <div className="text">
                                Shop Home &#38; Garden
                            </div>
                            <div className="arrow">
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    </a>

                    <a href="/shop-gadgets-electronics">
                    <div className="category">
                        <div className="cat3">
                            <div className="image">
                                <img alt="temp" src="https://cdn.shippingcart.com/images/front/shop-gadget-page.png" />
                            </div>
                            <div className="text">
                                Shop Gadgets &#38; Electronics
                            </div>
                            <div className="arrow">
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    </a>

                    <a href="/shop-fashion-clothing">
                    <div className="category">
                        <div className="cat4">
                            <div className="image">
                                <img alt="temp" src="https://cdn.shippingcart.com/images/front/shop-fashion-page.png" />
                            </div>
                            <div className="text">
                                Shop Fashion &#38; Clothing
                            </div>
                            <div className="arrow">
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    </a>

                    <a href="/mens-finds">
                    <div className="category">
                        <div className="cat5">
                            <div className="image">
                                <img alt="temp" src="https://cdn.shippingcart.com/images/front/shop-men-page2.png" />
                            </div>
                            <div className="text">
                                Men&#x27;s Finds
                            </div>
                            <div className="arrow">
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    </a>


                    <a href="/womens-finds">
                    <div className="category">
                        <div className="cat6">
                            <div className="image">
                                <img alt="temp" src="https://cdn.shippingcart.com/images/front/shop-women-page-2.png" />
                            </div>
                            <div className="text">
                                Women&#x27;s Finds
                            </div>
                            <div className="arrow">
                                <i className="fa fa-chevron-right" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    </a>

                    <div className="prohibited">
                        <div className="cat6">
                            <div className="image">
                                <img alt="temp" src="https://cdn.shippingcart.com/images/front/prohibited-icon-page.png" />
                            </div>
                            <div className="text">
                               NOTE: There are certain items that are prohibited. ShippingCart WILL NOT process any orders for these items. Check list  <a href="/prohibited-items">here</a>.
                            </div>

                        </div>
                    </div>

                </div>
              </div>
            </div>
          </section>


        </div>
      </div>
    )
  },
});
export default PageNotFound;



/** WEBPACK FOOTER **
 ** ./src/components/PageNotFound.js
 **/